export async function getWebglSendbirdApi() {
    const SendbirdChatModule = await import(/* webpackChunkName: "webgl-supply" */ '@sendbird/chat');
    const {ConnectionHandler} = SendbirdChatModule;
    const {
        GroupChannelModule,
        GroupChannelHandler
    } = await import(/* webpackChunkName: "webgl-supply" */ '@sendbird/chat/groupChannel');

    return {
        ConnectionHandler,
        GroupChannelHandler,
        GroupChannelModule,
        SendbirdChat: SendbirdChatModule.default
    };
}

